// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"410":"a667e0c9","690":"2d160844","941":"8736103d","965":"9ce419f5"}[chunkId] + ".chunk.css";
};